import CloseIcon from "@mui/icons-material/Close";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    IconButton,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { GridExpandMoreIcon } from "@mui/x-data-grid";

interface Props {
    show: any;
    setShowDetailMechanical: any;
}
export const DetallesDiagramaMecanico = ({
    show,
    setShowDetailMechanical,
}: Props) => {
    const handleShowDetailMechanical = (): void => {
        setShowDetailMechanical(!show);
    };
    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <IconButton
                    aria-label="delete"
                    onClick={handleShowDetailMechanical}
                    sx={{
                        backgroundColor: "#cf1919",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: "#ff3535",
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <Grid container spacing={2}>
                <Grid size={3}>
                    <TextField
                        id="location"
                        label="Locación"
                        fullWidth
                        size="small"
                        //   value={}
                        //   onChange={}
                    />
                </Grid>
                <Grid size={3}>
                    <TextField
                        id="date"
                        label="Fecha"
                        fullWidth
                        size="small"
                        //   value={}
                        //   onChange={}
                    />
                </Grid>
                <Grid size={3}>
                    <TextField
                        id="asignado"
                        label="Realizado por"
                        fullWidth
                        size="small"
                        //   value={}
                        //   onChange={}
                    />
                </Grid>
                <Grid size={3}>
                    <TextField
                        id="approved"
                        label="Aprobado por"
                        fullWidth
                        size="small"
                        //   value={}
                        //   onChange={}
                    />
                </Grid>

                <Grid size={12}>
                    <TextField
                        id="comment"
                        label="Comentarios"
                        fullWidth
                        size="small"
                        multiline
                        rows={4}
                        //   value={}
                        //   onChange={}
                    />
                </Grid>

                <Grid size={12}>
                    <Accordion
                        elevation={0}
                        sx={{
                            borderBottom: "1px solid #129ED3",
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<GridExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography component="span">Variables</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2}>
                                <Grid size={3}>
                                    <TextField
                                        id="variable"
                                        label="Variable X"
                                        fullWidth
                                        size="small"
                                        //   value={}
                                        //   onChange={}
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <TextField
                                        id="variable"
                                        label="Variable X"
                                        fullWidth
                                        size="small"
                                        //   value={}
                                        //   onChange={}
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <TextField
                                        id="variable"
                                        label="Variable X"
                                        fullWidth
                                        size="small"
                                        //   value={}
                                        //   onChange={}
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <TextField
                                        id="variable"
                                        label="Variable X"
                                        fullWidth
                                        size="small"
                                        //   value={}
                                        //   onChange={}
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
        </>
    );
};

export default DetallesDiagramaMecanico;
